// ==================================================
//  モバイル判定イベント
// ==================================================
function is_mobile() {
  const intFrameWidth = window.innerWidth;
  return intFrameWidth <= 767 ? true : false;
}

// ==================================================
//  制作実績 スライダー
// ==================================================
$(function () {
  const slider = ".worksDetailSlider-js";
  const thumbnailItem = ".worksDetailSliderThumbnail-js > div";

  $(thumbnailItem).each(function () {
    var index = $(thumbnailItem).index(this);
    $(this).attr("data-index", index);
  });

  $(slider).on("init", function (slick) {
    var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
    $(thumbnailItem + '[data-index="' + index + '"]').addClass("thumbnail-current");
  });

  $(slider).slick({
    infinite: false,
    autoplay: false,
    // fade: true,
    speed: 450,
    // cssEase: "linear",
    dots: false,
    arrows: false,
  });

  $(thumbnailItem).on("click", function () {
    var index = $(this).attr("data-index");
    $(slider).slick("slickGoTo", index, false);
  });

  $(slider).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    $(thumbnailItem).each(function () {
      $(this).removeClass("thumbnail-current");
    });
    $(thumbnailItem + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
  });
});
